var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 15a8.333 8.333 0 101.667 5h-6.666",
    stroke: "#FF5F5F",
    strokeWidth: 3
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGRkVERUQiLz4KPHBhdGggZD0iTTI2LjY2NjUgMTVDMjUuMTQ2MSAxMi45NzYxIDIyLjcyNjEgMTEuNjY2NyAxOS45OTk4IDExLjY2NjdDMTUuMzk3NSAxMS42NjY3IDExLjY2NjUgMTUuMzk3NiAxMS42NjY1IDIwQzExLjY2NjUgMjQuNjAyNCAxNS4zOTc1IDI4LjMzMzMgMTkuOTk5OCAyOC4zMzMzQzI0LjYwMjIgMjguMzMzMyAyOC4zMzMyIDI0LjYwMjQgMjguMzMzMiAyMEgyMS42NjY1IiBzdHJva2U9IiNGRjVGNUYiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { SvgGoogle as ReactComponent };